
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { SampleUICssStyles } from "@/types/singularity/brand";

@Component
export default class SampleUI extends Vue {
  @Prop({ type: Object, required: true }) cssStyles!: SampleUICssStyles;
}
